<template>
  <div class="interpretation">
    <h2>INTERPRETATION</h2>
    <div v-if="!store.currentAtbDataRow || !store.speciesText" style="width: 700px;font-size: 20px;">
      select antimicrobial and organism !
    </div>
    <div v-else>
      <div class="interpretation-content">
        <InterEcoff v-if="store.currentAtbDataRow['beta-lactamin '] === '1'" />
        <InterFt v-if="store.currentAtbDataRow['Ctrough'] === '1'" />
        <InterAUC v-if="store.currentAtbDataRow['AUC'] === '1'" />
        <InterCpeak v-if="store.currentAtbDataRow['Cpeak'] === '1'" />
        
        <!-- Collapsible References Section -->
        <div class="references-section">
          <div @click="toggleReferences" class="references-toggle">
            <span class="references-label">References</span>
            <span class="toggle-icon" :class="{ 'expanded': showReferences }">▼</span>
          </div>
          
          <div v-show="showReferences" class="references-content">
            <p class="interpretation-description">
              The application provides a concise, structured interpretation for time-dependent antibiotics (initially beta-lactams) based on established PK/PD targets (e.g., 100% fT&gt;4xMIC)<sup>1, 2</sup>. The output delivers three crucial insights:
            </p>
            
            <ol class="references-list">
              <li>
                Guilhaumou R, Benaboud S, Bennis Y, Dahyot-Fizelier C, Dailly E, Gandia P, et al. 
                Optimization of the treatment with beta-lactam antibiotics in critically ill patients—guidelines 
                from the French Society of Pharmacology and Therapeutics (Société Française de Pharmacologie 
                et Thérapeutique—SFPT) and the French Society of Anaesthesia and Intensive Care Medicine 
                (Société Française d'Anesthésie et Réanimation—SFAR). Crit Care. 29 mars 2019;23(1):104.
              </li>
              <li>
                Abdul-Aziz MH, Alffenaar JWC, Bassetti M, Bracht H, Dimopoulos G, Marriott D, et al. 
                Antimicrobial therapeutic drug monitoring in critically ill adult patients: a Position Paper. 
                Intensive Care Med. juin 2020;46(6):1127‑53.
              </li>
            </ol>
            <p class="references-note">
              <em>non-exhaustive list of publications agreeing on the therapeutic targets to be achieved.</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useTestStore } from "@/stores/testStore";
import InterEcoff from "@/components/all-inters/InterEcoff.vue";
import InterFt from "@/components/all-inters/InterFt.vue";
import InterAUC from "@/components/all-inters/interAUC.vue";
import InterCpeak from "@/components/all-inters/InterCpeak.vue";

// Initialize the store
const store = useTestStore();

// References collapsible state
const showReferences = ref(false);

const toggleReferences = () => {
  showReferences.value = !showReferences.value;
};
</script>

<style scoped>
.interpretation {
  display: flex;
  justify-content: start;
  flex-direction: column;
  margin: 14px 150px 0px 30px;
  padding: 10px 10px 50px 10px;
  align-items: center;
  border: rgb(204, 161, 161) 3px solid;
  border-radius: 15px;
}

.interpretation-content {
  width: 100%;
}

.interpretation-description {
  font-size: 13px;
  margin-bottom: 15px;
  text-align: left;
  line-height: 1.5;
  color: #495057;
}

.references-section {
  margin-top: 30px;
  width: 100%;
}

.references-toggle {
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-size: 13px;
  color: #6c757d;
  transition: color 0.2s;
  border: none;
  background: none;
}

.references-toggle:hover {
  color: #495057;
}

.references-label {
  font-weight: 500;
}

.toggle-icon {
  transition: transform 0.2s;
  font-size: 12px;
}

.toggle-icon.expanded {
  transform: rotate(180deg);
}

.references-content {
  padding: 15px 0;
  background: transparent;
}

.references-list {
  margin: 0;
  padding-left: 20px;
  font-size: 12px;
  line-height: 1.4;
}

.references-list li {
  margin-bottom: 15px;
  text-align: justify;
}

.references-note {
  margin-top: 15px;
  margin-bottom: 0;
  font-size: 12px;
  color: #6c757d;
}
</style>